import { Head } from "zudoku/components";
import { readOperation } from "../lib/oas";
import { OperationForm } from "../components/OperationForm";

// The ReadMe.io-style operation page (header, Form Data inline, Headers,
// Responses, sidecar with live code samples + response) applied to every
// operation — see zudoku.config.tsx, which registers one of these as a
// custom-page per entry in scripts/sidebar-map.json, at the operation's
// real canonical URL (replacing Zudoku's default click-to-open dialog page
// at that same path).
export function OperationPage({ spec, operationId }: { spec: any; operationId: string }) {
  const op = readOperation(spec, operationId);

  return (
    <>
      <Head>
        <title>{op.summary}</title>
      </Head>
      <div className="pt-(--padding-content-top)">
        <h1 className="text-3xl font-semibold mb-4">{op.summary}</h1>
        <OperationForm op={op} />
      </div>
    </>
  );
}
